import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { ToastrService } from 'ngx-toastr';
import { HelpService } from '../help.service';

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.less']
})
export class HelpCenterComponent implements OnInit {
  csoList = [];
  CSOForm: FormGroup;
  user: any = {};
  submitted = false;
  term = "";
  issueCategories: any = [];

  constructor(private titleService: Title, private HelpServices: HelpService, private formBuilder: FormBuilder, private toastr: ToastrService, private sharedUtilService: SharedUtilService) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.titleService.setTitle('Help Center');

    this.issueCategories = ['DEPENDENT_ISSUE', 'CONFIGURATION_ISSUE', 'FEATURE_GAP', 'AVAILABILITY_ISSUE'];

    this.getListCSO();
    this.setForm();
  }

  setForm() {
    this.CSOForm = this.formBuilder.group({
      id: [null],
      error: ['', Validators.required],
      errorDescription: [''],
      rootCause: [''],
      contactSupport: [''],
      issueCategory: ['', [Validators.required]],
      errorReportedBy: ['', [Validators.required, Validators.email]]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.CSOForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.CSOForm);

    if (this.CSOForm.invalid) return;

    if (this.CSOForm.value.id) {
      this.update(this.CSOForm.value);

    } else {
      this.save(this.CSOForm.value);
    }
  }

  onReset() {
    this.submitted = false;
    this.CSOForm.reset();
  }

  save(obj) {
    this.HelpServices.saveCSO(obj).pipe().subscribe(data => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.getListCSO();
        this.onReset();
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  update(obj) {
    this.HelpServices.updateCSO(obj).pipe().subscribe(data => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.getListCSO();
        this.onReset();
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  deleteCSO(item) {

    const confirmMsg = 'Do you want to delete ? ';
    this.sharedUtilService.openConfirmDialog(confirmMsg, false).then(result => {
      if (result) {
        this.HelpServices.deleteCSO(item.id).pipe().subscribe(data => {
          if (data.code === 200) {
            this.toastr.success(data.message);
            this.getListCSO();
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }

  editCSO(item) {
    this.submitted = false;
    this.CSOForm.patchValue({ ...item });
  }

  getListCSO() {
    this.HelpServices.getCSOList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.csoList = data.response;
      } else {
        this.csoList = [];
      }
    });
  }

}
